import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Dashboard } from './pages/Dashboard';
import { SafetyPage } from './pages/SafetyPage';
import { ClassroomPage } from './pages/ClassroomPage';
import { GrowthPage } from './pages/GrowthPage';
import { KnowledgePage } from './pages/KnowledgePage';
import { AITutorPage } from './pages/AITutorPage';
function App() {
  return <BrowserRouter data-id="element-0">
      <Routes data-id="element-1">
        <Route path="/" element={<Dashboard data-id="element-3" />} data-id="element-2" />
        <Route path="/safety" element={<SafetyPage data-id="element-5" />} data-id="element-4" />
        <Route path="/classroom" element={<ClassroomPage data-id="element-7" />} data-id="element-6" />
        <Route path="/growth" element={<GrowthPage data-id="element-9" />} data-id="element-8" />
        <Route path="/knowledge" element={<KnowledgePage data-id="element-11" />} data-id="element-10" />
        <Route path="/ai-tutor" element={<AITutorPage data-id="element-13" />} data-id="element-12" />
      </Routes>
    </BrowserRouter>;
}
export { App };